import { AppMenuItem } from '../../../shared/ui/AppMenuItem'
import {
  useCurrentRecommendationCatalog,
  useRecommendationAccess,
} from './recommendation-access-context'
import './recommendation-attention.css'

export function RecommendationMenuEntry({
  onClick,
  account,
}: {
  onClick: () => void
  account?: string
}) {
  const data = useCurrentRecommendationCatalog(account)
  const { access } = useRecommendationAccess()
  if (!data || data.total === 0) return null
  return (
    <AppMenuItem
      className={
        data.seenCount < data.total ? 'recommendation-menu-attention' : ''
      }
      onClick={() => {
        onClick()
        if (access?.isCurrent()) access.requestOpen()
      }}
    >
      <span>Смотреть рекомендации</span>
    </AppMenuItem>
  )
}
